import { render, staticRenderFns } from "./DrivewealthInvestmentPage.vue?vue&type=template&id=b3e99490"
import script from "./DrivewealthInvestmentPage.vue?vue&type=script&lang=ts"
export * from "./DrivewealthInvestmentPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports